import styled, { css } from 'styled-components';
import { hexToRgbA } from '@/utilities/colors';

export interface TruncatorWrapperProps {
  open: boolean;
  maxHeight: number;
  minHeight: number;
  setToAutoHeight: boolean;
  animationDuration?: number;
  showGradient: boolean;
}

const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;

export const TruncatorWrapper = styled('div').attrs<TruncatorWrapperProps>(
  ({ setToAutoHeight }) => {
    if (setToAutoHeight) {
      return {
        style: {
          height: 'auto',
          overflowY: 'visible',
        },
      };
    }
  }
)<TruncatorWrapperProps>`
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  transition: height ${({ animationDuration }) => animationDuration || 0.5}s
    ${cubicBezier};
  height: ${({ open, minHeight, maxHeight }) =>
    open ? maxHeight : minHeight}px;
  &:after {
    position: absolute;
    display: block;
    content: '';
    bottom: 0;
    width: 100%;
    transition: opacity 0.4s, height 0.4s;
    opacity: ${({ open }) => (open ? 0 : 1)};
    height: ${({ theme, open }) => (open ? 0 : theme.x4spacePx)}px;
    ${({ showGradient }) =>
      showGradient &&
      css`
        background: linear-gradient(
          to bottom,
          ${({ theme }) => hexToRgbA(theme.color.charcoal, 0)},
          ${({ theme }) => hexToRgbA(theme.color.charcoal, 1)}
        );
      `}
  }
`;
